import { render } from "./predictive-search-results.vue?vue&type=template&id=bb5bbbee"
import script from "./predictive-search-results.vue?vue&type=script&lang=js"
export * from "./predictive-search-results.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__